<h3 align="center">Post Quantum and Cloud Cryptography</h3>
<p>
    Il corso è riservato ai soci di “De Componendis Cifris APS”, per i quali è completamente gratuito (vedi a <a
        routerLink="/associarsi">questo link</a> come associarsi).
</p>
<p>
    Si tratta della seconda fruizione, pertanto i soci che si iscrivono entro il 25 settembre 2023 possono seguire le
    lezioni registrate che si trovano nella sezione <a routerLink="/trends22">Edizione 2022</a>. Ci aspettiamo che
    gli iscritti al corso completino la visione dei video entro il 17 novembre.
</p>
<p>
    Nel periodo dal primo ottobre al 17 novembre, gli studenti possono fare domande e avere assistenza sul corso,
    scrivendo al Dott. Marzio Mula (<a href="mailto:marziomula@gmail.com">marziomula&#64;gmail.com</a>).
</p>
<p>
    Infine, gli iscritti che vogliano ottenere un certificato di partecipazione al corso, devono sostenere l'esame
    (online) il 27 Novembre 2023, il 5 Dicembre 2023, o il <b>29 Gennaio alle 15:00</b>.
</p>
<hr>
<h3 align="center"> FULL DESCRIPTION IN ENGLISH</h3>
<p>
    De Cifris members are again offered the opportunity to take the final exam of the course <a href="/trends22">De
        Cifris Trends in Modern Cryptography 2022</a>
</p>

<h4>Organizers</h4>

<p>
    Massimiliano Sala and Marzio Mula.
</p>

<h4> Language </h4>

<p>
    English.
</p>

<h4> How to sign up</h4>

<p>
    The exam can only be taken by De Cifris members. Directions for becoming a member are available on <a
        href="/associarsi">this page</a>.
</p>
<p>
    <b>Deadline:</b> 25th September 2023 (send an email to <a href="mailto:trends@decifris.it">trends&#64;decifris.it</a>)
</p>
<h4> Lessons</h4>
<div class="row">
    <div class="col-md-12">
        <h5> Part 1: Post Quantum Cryptography </h5>
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col">Title and link</th>
                    <th scope="col">Topics</th>
                    <th scope="col">Lecturers</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        Course introduction <br>
                        (<a href="https://www.youtube.com/watch?v=MEluBT1sr7Y&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=1"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>Sketch of the course</li>
                            <li>Introduction to post-quantum cryptography</li>
                            <li>Intro to cloud encryption</li>
                            <li>Intro to complexity theory</li>
                        </ul>
                    </td>
                    <td>
                        Massimiliano Sala<br>
                        Marco Calderini <br>
                        (UNITN)</td>
                </tr>
                <tr>
                    <td>
                        Lattices mod 1 <br>
                        (<a href="https://www.youtube.com/watch?v=ExWp6fxxZ9A&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=2"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        Linear algebra over lattices:
                        <ul>
                            <li>Basis of a lattice</li>
                            <li>Dimension of a lattice</li>
                            <li>Length and distance</li>
                        </ul>
                    </td>
                    <td>Lea Terracini <br> (UNITO)</td>
                </tr>
                <tr>
                    <td>
                        Lattices mod 2 <br>
                        (<a href="https://www.youtube.com/watch?v=xghX--ZhTrk&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=3"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        Determinant:
                        <ul>
                            <li>Fundamental Domain</li>
                            <li>Determinant</li>
                            <li>Hadamard’s inequality</li>
                            <li>Hermite’s Theorem</li>
                        </ul>
                    </td>
                    <td>Giordano Santilli <br> (UNITN)</td>
                </tr>
                <tr>
                    <td>
                        Problems over lattices <br>
                        (<a href="https://www.youtube.com/watch?v=xIzJlBLqhQY&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=4"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>SVP and CVP</li>
                            <li>Appr-SVP</li>
                            <li>Gaussian heuristic</li>
                            <li>LLL</li>
                            <li>Babai’s Closest Vertex Algorithm</li>
                        </ul>
                    </td>
                    <td>Stefano Barbero <br> (POLITO)</td>
                </tr>
                <tr>
                    <td>
                        Complexity of the <br> problems for lattices <br>
                        (<a href="https://www.youtube.com/watch?v=qap3oV3EZ3U&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=5"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>Complexity of SVP</li>
                            <li>Complexity of CVP</li>
                            <li>Complexity of their approximate versions</li>
                        </ul>
                    </td>
                    <td>Massimo Lauria <br> (Roma Sapienza)</td>
                </tr>
                <tr>
                    <td>
                        NTRU encryption <br>
                        (<a href="https://www.youtube.com/watch?v=jxqeIRtLgHI&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=6"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>The encryption algorithm (classical) NTRU</li>
                            <li>The NTRU-HRSS-KEM (NIST submission round 2)</li>
                        </ul>
                    </td>
                    <td>Nadir Murru <br> (UNITN)</td>
                </tr>
                <tr>
                    <td>
                        Attacks to NTRU <br>
                        (<a href="https://www.youtube.com/watch?v=cF3IXLyzQ9A&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=7"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>Coppersmith and Shamir</li>
                            <li>Other attacks</li>
                        </ul>
                    </td>
                    <td>Andrea Visconti <br> (UNIMI)</td>
                </tr>
                <tr>
                    <td>
                        LWE <br>
                        (<a href="https://www.youtube.com/watch?v=JaX5MoeKAXU&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=8"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>LWE on lattices</li>
                            <li>LWE on polynomial rings</li>
                        </ul>
                    </td>
                    <td>Roberto Civino <br> (UNIVAQ)</td>
                </tr>
                <tr>
                    <td>
                        Crystals & Saber <br>
                        (<a href="https://www.youtube.com/watch?v=8abaR_2bWfQ&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=9"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>The cryptosystems Crystals, Kyber and Dilithium </li>
                            <li>The cryptosystem Saber</li>
                        </ul>
                    </td>
                    <td>Andrea Basso <br> (University of Birmingham)</td>
                </tr>
                <tr>
                    <td>Problems on codes <br>
                        (<a href="https://www.youtube.com/watch?v=o1-ftvM8rFo&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=10"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>Linear codes</li>
                            <li>The MLD problem</li>
                            <li>The equivalence problem</li>
                        </ul>
                    </td>
                    <td>Marco Timpanella <br> (UNIPG)</td>
                </tr>
                <tr>

                    <td>
                        Code-based cryptography <br>
                        (<a href="https://www.youtube.com/watch?v=YLgE13JpQWM&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=11"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>McEliece</li>
                            <li>Niederreiter</li>
                            <li>LEDAcrypt</li>
                        </ul>
                    </td>
                    <td>Marco Baldi <br> (UNIVPM)</td>
                </tr>
                <tr>
                    <td>
                        Foundations of multivariate crypto <br>
                        (<a href="https://www.youtube.com/watch?v=HpL0PqkFn7I&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=12"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>Definition of the MQ problem</li>
                            <li>Methods to solve multivariate polynomial systems</li>
                            <li>Special methods for the finite field case</li>
                        </ul>
                    </td>
                    <td>Michela Ceria <br> (POLIBA)</td>
                </tr>
                <tr>

                    <td>
                        Rainbow digital signature <br>
                        (<a href="https://www.youtube.com/watch?v=C8LP7mzpwgo&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=13"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>The digital signature scheme Rainbow</li>
                            <li>Security of Rainbow</li>
                        </ul>
                    </td>
                    <td>Roberto La Scala <br> (UNIBA)</td>
                </tr>
            </tbody>
        </table>
        <h5> Part 2: Cloud Cryptography </h5>
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col">Title and link</th>
                    <th scope="col">Topics</th>
                    <th scope="col">Lecturers</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        ABE-paring <br>
                        (<a href="https://www.youtube.com/watch?v=eaTZZn6AnWo&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=14"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>Formal properties of pairings</li>
                            <li>Tate pairing</li>
                            <li>Weil pairing</li>
                        </ul>
                    </td>
                    <td>Laura Capuano <br> (ROMA3)</td>
                </tr>
                <tr>
                    <td>
                        ABE-IBE <br>
                        (<a href="https://www.youtube.com/watch?v=3vPiWQO7YsE&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=15"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>Boneh Franklin scheme</li>
                            <li>Fuzzy IBE</li>
                        </ul>
                    </td>
                    <td>Annamaria Iezzi <br> (UNINA)</td>
                </tr>
                <tr>
                    <td>
                        Ciphertext-policy ABE <br>
                        (<a href="https://www.youtube.com/watch?v=y4TkZOUdEVI&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=16"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>CP-ABE based on pairings</li>
                        </ul>
                    </td>
                    <td>Marco Pedicini <br> (ROMA3)</td>
                </tr>
                <tr>
                    <td>
                        Key-policy ABE <br>
                        (<a href="https://www.youtube.com/watch?v=zb-e44Yjt6w" target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>Key policy ABE</li>
                            <li>Revocable storage</li>
                        </ul>
                    </td>
                    <td>Riccardo Longo <br> (UNITN)</td>
                </tr>
                <tr>
                    <td>
                        Functional Encryption I <br>
                        (<a href="https://www.youtube.com/watch?v=7Bmuk-0plJA&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=17"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>Introduction to Functional Encryption</li>
                            <li>Security notions and mathematical assumptions</li>
                        </ul>
                    </td>
                    <td>Irene Villa <br> (UNITN)</td>
                </tr>
                <tr>
                    <td>
                        Functional Encryption II <br>
                        (<a href="https://www.youtube.com/watch?v=po6TTrOxFxU&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=18"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>Predicate Encryption (PE)</li>
                            <li>PE with public index</li>
                            <li>PE with private index</li>
                        </ul>
                    </td>
                    <td>Carla Mascia <br> (UNITN)</td>
                </tr>
                <tr>
                    <td>
                        Secure multi-party <br> computation <br>
                        (<a href="https://www.youtube.com/watch?v=wQLLJugFuzs&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=19"
                            target="_blank">Video</a>)
                    </td>
                    <td>
                        <ul>
                            <li>Security goals and proofs</li>
                            <li>MPC based on Threshold Secret Sharing</li>
                            <li>SPDZ</li>
                        </ul>
                    </td>
                    <td>Mario Di Raimondo <br> (UNICT)</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<h4>Test </h4>
<p> The participants who pass an online test (oral exam) will receive a "Course Attendance" certificate.</p>
<h4> Slides </h4>
<p> <a href="/assets/attivita/deCifrisTrends/SlidesTrendsinModernCrypto.zip">Slides</a> of the presentations are
    available.</p>
<h4> Contacts </h4>
<p> For any further information about the registration, or any questions about the lessons, send an email to <a
        href="mailto:@marziomula@gmail.com">marziomula&#64;gmail.com</a>.</p>
